<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import SelectSite from '@/components/forms/copySite/forms/SelectSite';
import Treeview from '@/components/forms/copySite/forms/TreeView';
import Analyses from '@/components/forms/copySite/forms/Analyses';
import Others from '@/components/forms/copySite/forms/Others';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        currentSite: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [SelectSite, Treeview, Analyses, Others],
            model: {
                selectedSite: null,
                selectedTreeNodes: {},
                analyses: {
                    workOrderType: true,
                    standards: true,
                    analysisRequestTemplates: true,
                    controlChart: true,
                },
                others: {
                    alerts: true,
                    graphics: true,
                },
            },
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    async created() {
        this.loading = true;
        this.tabs = this.tableHeaders();
        this.reset();
        this.loading = false;
    },
    methods: {
        ...mapActions({
            setSite: 'changeSelectedSite',
            setTree: 'changeSelectedTree',
        }),
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: this.model,
                name: this.$t(`copySite.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            if (newData.selectedTreeNodes) {
                this.setTree(newData.selectedTreeNodes);
            }
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
        reset() {
            this.$store.dispatch('changeActiveTab', 0);
            this.setSite(null);
        },
    },
};
</script>
